import axios from 'axios';

import { exportConstants } from '../constants';

export const exportActions = {
    exportData,
    exportBusinessCase,
};

const postExport = (req, expandedPeriods, allocations) =>
    axios.post(
        '/export',
        {
            template: {
                non_calculated_only: !!req.nonCalculatedOnly,
                result_business_cases: !!req.resultBusinessCases,
                export_entity: [
                    ...(req.scenarioIds || []).map((id) => ({ entity_id: id, entity_type: 'scenario' })),
                    ...(req.businessCaseIds || []).map((id) => ({ entity_id: id, entity_type: 'business' })),
                ],
            },
            expandedPeriods,
            allocations,
        },
        {
            timeout: 120000, // 2 min — fail fast on the client side
        }
    );

const exportErrorMessage = (err) => {
    const status = err?.response?.status;
    const isTimeout = status === 504 || status === 408 || err?.code === 'ECONNABORTED';

    return isTimeout
        ? 'The export is too large. Please reduce the number of scenarios or business cases and try again.'
        : (err?.response?.data?.error ||
           err?.response?.data?.toString?.() ||
           err?.message ||
           'Unable to export data at this moment. Please try again later.');
};

function exportData(req) {
    return async (dispatch, getState) => {
        dispatch({ type: exportConstants.EXPORT_DATA_REQUEST });

        try {
            const expandedPeriods = getState().periods.expandedPeriods;
            const allocations = getState().allocations.allocations;

            const res = await postExport(req, expandedPeriods, allocations);

            dispatch({ type: exportConstants.EXPORT_DATA_SUCCESS, data: res.data });
        } catch (err) {
            dispatch({ type: exportConstants.EXPORT_DATA_FAILURE, error: exportErrorMessage(err) });
        }
    };
}

/**
 * One-click export of a business case: its total plus every scenario in it.
 * Returns the export data rather than storing it, so it does not disturb the
 * Export page. Throws an Error with a user-facing message on failure.
 */
function exportBusinessCase(businessCaseId, { includeAllocations = true } = {}) {
    return async (dispatch, getState) => {
        const expandedPeriods = getState().periods.expandedPeriods;
        const allocations = includeAllocations
            ? (getState().allocations.allocations || []).filter(
                  (a) => Number(a?.businessCaseId ?? a?.business_case_id) === Number(businessCaseId)
              )
            : [];

        try {
            const res = await postExport(
                { businessCaseIds: [businessCaseId], resultBusinessCases: true },
                expandedPeriods,
                allocations
            );
            return res.data;
        } catch (err) {
            throw new Error(exportErrorMessage(err));
        }
    };
}
